import React, { useState, useEffect } from 'react';
import $ from 'jquery';
import axios from 'axios';
import api from '../../../api/axiosInstance';
const FormMasterJobCategories = ({
  formId,
  formMasterJobCategories,
  formJobCategories,
  onJobCategoryAdded,
  onJobCategoryDeleted,
  handleSaveFromMasterSection,
  OnColumnnumberChange,
  shouldDisableFields
}) => {debugger;
  const [selectedJobCategory, setSelectedJobCategory] = useState('');
  const [formMasterJobCategoriesState, setFormMasterJobCategoriesState] = useState([]); // Store added categories
  const [formJobCategoriesState, setFormJobCategoriesState] = useState([]); // Store available categories
  const [columnsValue,setColumnValue] = useState([]);
  const [loading, setLoading] = useState(false);
    const [blocked, setBlocked] = useState(false);

  // Fetch and update job categories when the component mounts
useEffect(() => {
  setLoading(true); 
  setFormMasterJobCategoriesState(formMasterJobCategories || []);
  setFormJobCategoriesState(formJobCategories || []);

  setTimeout(() => {
    setLoading(false); // Stop loading after data is fetched
  }, 1000); // Adjust time as necessary
  // Ensure AdminLTE's DataTable function is available
  if(formMasterJobCategoriesState!=null ||formMasterJobCategoriesState!=undefined)
  {if (!window.$) {
    window.$('#example2').DataTable({
      responsive: true,
      autoWidth: false,
      searching: true,
      // ordering: true,
      // sorting: true,
      pageLength: 10,
      lengthChange: false,
      paging: true,
      info: true,
    });
  }
}
}, [formMasterJobCategories, formJobCategories]);


  // useEffect(() => {
  //   if(formMasterJobCategories)
  // }, [formMasterJobCategories]);

  const handleJobCategoryChange = (e) => {
    setSelectedJobCategory(e.target.value);
  };

  const handleAddJobCategory = () => {
    debugger;
    if (selectedJobCategory) {
      const newJobCategory = {
        FormMasterId: formId,
        JobCategoryId: selectedJobCategory,
      };
      debugger;

      // Call the parent function to add the job category
      onJobCategoryAdded(newJobCategory);

      
          setSelectedJobCategory('');

          // Show a success message
          $.alert({
            title: 'Success',
            content: 'Job Category added successfully.',
            type: 'green',
          });
        
    } else {
      $.alert({
        title: 'Error',
        content: 'Please select a Job Category.',
        type: 'red',
      });
    }
  };

  const handleDeleteJobCategory = (jobCategoryId) => {
    $.confirm({
      title: 'Confirm Deletion',
      content: 'Do you really want to delete this?',
      buttons: {
        confirm: {
          text: 'Yes',
          btnClass: 'btn-danger',
          action: () => {debugger;
            // Call the parent function to delete the job category
            onJobCategoryDeleted(jobCategoryId);


            const updatedFormMasterCategories = formMasterJobCategoriesState.filter(
              (category) => category.id !== jobCategoryId
            );
            setFormMasterJobCategoriesState(updatedFormMasterCategories==null?[]:updatedFormMasterCategories);
    setBlocked(false);
            // // Remove the deleted category from the state (refresh the grid and dropdown)
            // const updatedFormMasterCategories = formMasterJobCategoriesState.filter(
            //   (category) => category.id !== jobCategoryId
            // );
            // setFormMasterJobCategoriesState(updatedFormMasterCategories);

            // const updatedFormJobCategories = formJobCategoriesState.filter(
            //   (category) => category.id !== jobCategoryId
            // );
            // setFormJobCategoriesState(updatedFormJobCategories);

            // // Show success message
            // $.alert({
            //   title: 'Success',
            //   content: 'Record deleted successfully.',
            //   type: 'green',
            // });
          }
        },
        cancel: {
          text: 'No',
          btnClass: 'btn-secondary',
        }
      }
    });
  };


   // Handle adding all missing categories
   const handleAddAllJobCategories = () => {debugger;
    const jobCategoriesToAdd = formJobCategoriesState.filter((dropdownCategory) => {
      return !formMasterJobCategoriesState.some(
        (addedCategory) => addedCategory.jobCategoryId === dropdownCategory.jobCategoryId
      );
    });
    debugger;

    if (jobCategoriesToAdd.length === 0) {
      $.alert({
        title: 'Info',
        content: 'All job categories have already been added.',
        type: 'blue',
      });
      return;
    }

    // Add all missing job categories
    debugger;
    jobCategoriesToAdd.forEach((category) => {
      const formMasterJobCategory = {
        FormMasterId: formId,
        JobCategoryId: category.id,
        JobCategoryName: category.name,
      };
      debugger;
      onJobCategoryAdded(formMasterJobCategory);
      debugger;
    });

    // Show success message
    $.alert({
      title: 'Success',
      content: 'All missing job categories have been added.',
      type: 'green',
    });

    // Optionally refresh the job categories list after adding
    debugger;
    setFormMasterJobCategoriesState([...formMasterJobCategoriesState, ...jobCategoriesToAdd]);
    debugger;
  };

  const OnColumnChange=(value)=>{debugger;
    OnColumnnumberChange(value);
    setColumnValue(value);
  }

  // Inside FormMasterJobCategories component

const SaveFromMasterSection = (formId) => {
  if (columnsValue !== null && columnsValue !== undefined && columnsValue !== 0) {
    handleSaveFromMasterSection(formId);
    window.$('#modal-default').modal('hide'); 

  }
};

// Determine whether to show the "Add All" button
const jobCategoriesToAdd = formJobCategoriesState.filter((dropdownCategory) => {
  return !formMasterJobCategoriesState.some(
    (addedCategory) => addedCategory.jobCategoryId === dropdownCategory.jobCategoryId
  );
});

const showAddAllButton = jobCategoriesToAdd.length > 0;

  const backdropStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100vw",
  height: "100vh",
  background: "rgba(0,0,0,0.2)", // light dark shade
  zIndex: 9998,
  cursor: "wait"  // cursor changes to loading
};

const overlayStyle = {
  position: "fixed",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  background: "#222",
  padding: "30px 50px",
  borderRadius: "12px",
  zIndex: 9999,
  color: "#fff",
  fontSize: "22px",
  textAlign: "center",
  cursor: "wait" // cursor loading
};


  return (
    <div className="card card-success mt-4">
           {blocked && (
  <>
    {/* FULL SCREEN BACKDROP THAT BLOCKS CLICKS */}
    <div style={backdropStyle}></div>

    {/* CENTER BOX */}
    <div style={overlayStyle}>
      <div className="spinner-border" role="status"></div>
      <div>Please wait…</div>
    </div>
  </>
)}
      <div className="card-header">
        <h5>Form Master Job Categories</h5>
      </div>

      <div className="card-body">
        <div className="form-group d-block align-items-center">
          <label htmlFor="jobCategoryDropdown" className="mr-2">
            Select Job Category:
          </label>
          <select
            id="jobCategoryDropdown"
            className="form-control"
            value={selectedJobCategory}
            onChange={handleJobCategoryChange}
            style={{ width: '50%' }}
            disabled={shouldDisableFields} 
          >
            <option value="" disabled>
              -- Select Job Category --
            </option>
            {formJobCategoriesState.map((job) => (
              <option key={job.id} value={job.id}>
                {job.name}
              </option>
            ))}
          </select>

          <div className="d-flex ml-auto mt-3">
            <button className="btn btn-success mr-2" onClick={handleAddJobCategory}   disabled={shouldDisableFields} >
              Add
            </button>
            {showAddAllButton && (
              <button className="btn btn-warning" 
              onClick={handleAddAllJobCategories}
              disabled={shouldDisableFields} 
              >
                Add All
              </button>
            )}
          </div>
        </div>

        {/* Display the added categories */}
        {(Array.isArray(formMasterJobCategoriesState) && formMasterJobCategoriesState.length === 0) ? (
          <p>No job categories added yet.</p>
        ) : (
          <table id="example2" className="table table-bordered table-striped mt-3" shouldDisableFields={shouldDisableFields}>
            <thead>
              <tr>
                <th width="77%">Job Category1</th>
                <th width="8%">Added On</th>
                <th width="3%">Action</th>
              </tr>
            </thead>
            <tbody>
              {formMasterJobCategoriesState.map((category) => (
                <tr key={category.id}>
                  <td>{category.jobCategoryName}</td>
                  <td>{new Date(category.createdOn).toLocaleDateString()}</td>
                  <td>
                    <button
                      className="btn btn-xs btn-danger"
                      onClick={() => handleDeleteJobCategory(category.id)}
                      title="Delete"
                      disabled={shouldDisableFields} 
                    >
                      <i className="fa fa-trash"></i>
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
      <div className="card-footer">
      <button type="button" class="btn btn-success" data-toggle="modal" data-target="#modal-default"   disabled={shouldDisableFields} >
                  Add New Section
                </button>
        </div>
        <div className="modal fade" id="modal-default">
  <div className="modal-dialog">
    <div className="modal-content">
      <div className="modal-header">
        <h4 className="modal-title">No. of Columns</h4>
        <button type="button" className="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div className="modal-body">
      <div className="col-sm-6">
  {/* select */}
  <div className="form-group">
    <label>Select No. of Columns</label>
    <select className="form-control"  onChange={(e) => OnColumnChange(e.target.value)}>
      <option value="1">1</option>
      <option value="2">2</option>
      <option value="3">3</option>
      <option value="4">4</option>
    </select>
  </div>
</div>

      </div>
      <div className="modal-footer justify-content-between">
        <button type="button" className="btn btn-default" data-dismiss="modal">Close</button>
        <button type="button" className="btn btn-primary" onClick={()=>SaveFromMasterSection(formId)}>Save changes</button>
      </div>
    </div>
    {/* /.modal-content */}
  </div>
  {/* /.modal-dialog */}
</div>

    </div>
     
  );
};

export default FormMasterJobCategories;
